export const initialState = {

    auth:{
        isAuth : false,
        user : null
    },
    document : {
        docId : "",
        uid : "" ,
        skinCode : "skin1" ,
    },
    contactDetails : {
        fname:"",
        lname:"",
        summary:"",
        email:"",
        phone:"",
        profession:"",
        street:"",
        city:"",
        state:"",
        country:"",
        pin:""
    },
    educationDetails:{
        collegeName:"",
        degree:"",
        cgpa:"",
        city:"",
        state:"",
        graduationMonth:"",
        graduationYear:"",
        experience:""
    },
    skillsDetails:{
        skill1:"",
        skill2:"",
        skill3:"",
        skill4:"",
        skill5:"",
        skill6:""
    }
}
